export default __webpack_public_path__ + "static/media/online-classrooms.12b38573.svg";